// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2awgc","inner":"Footer_inner__3Z4tH","nextIcon":"Footer_nextIcon__3HP38","innerLeft":"Footer_innerLeft__1lVfW"};